import React from 'react'
import '../admin/admin.css'
import { Link } from 'react-router'

const Admin = () => {
  return (
    <div className="admin-container">
      Admin panel
      <Link to="/admin/courses">
        <button>Управление курсами</button>
      </Link>
      <Link  to="/admin/students">
        <button>Управление студентами</button>
      </Link>
    </div>
  )
}

export default Admin
